class ProductStickyAtc extends HTMLElement {
  constructor() {
    super();

    this.onVariantChanged = this.onVariantChanged.bind(this);
    this.onMainQuantityChange = this.onMainQuantityChange.bind(this);
    this.onStickyQuantityChange = this.onStickyQuantityChange.bind(this);
    this.onStickySubmit = this.onStickySubmit.bind(this);
    this.onSectionLoad = this.onSectionLoad.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this); // NEW

    this.isSyncingQuantity = false;
    this.isVisible = false;
    this.hiddenByFooter = false;
    this.buyButtonsObserver = null;
    this.footerObserver = null;
    this.buttonObserver = null;
    this.mobileQuery = window.matchMedia('(max-width: 699px)'); // NEW
  }

  connectedCallback() {
    this.sectionId = this.dataset.sectionId || '';
    this.sectionRoot = this.closest('.shopify-section') || document;
    this.productForm = document.getElementById(this.dataset.productFormId || '');
    this.stickyQuantityInput = this.querySelector('[data-sticky-atc-quantity]');
    this.stickyImage = this.querySelector('[data-sticky-atc-image]');
    this.stickyVariant = this.querySelector('[data-sticky-atc-variant]');
    this.stickyButton = this.querySelector('[data-sticky-atc-submit]');

    this.bindMainFormNodes();
    this.syncFromMain();

    document.addEventListener('variant:changed', this.onVariantChanged);
    document.addEventListener('shopify:section:load', this.onSectionLoad);
    this.mobileQuery.addEventListener('change', this.onBreakpointChange); // NEW
    this.stickyQuantityInput?.addEventListener('change', this.onStickyQuantityChange);
    this.stickyQuantityInput?.addEventListener('input', this.onStickyQuantityChange);
    this.stickyButton?.addEventListener('click', this.onStickySubmit);

    if (!this.buyButtonsBlock) {
      this.setAttribute('aria-hidden', 'true');
      return;
    }

        this.removeAttribute('hidden');
    this.classList.add('is-mounted');
    this.setAttribute('aria-hidden', 'true');

    // Show instantly on first load (no slide-up animation)
    this.classList.add('is-instant');
    this.setupObservers();
    this.updateVisibilityFromLayout();

    // Re-enable the animation for later show/hide while scrolling
    window.setTimeout(() => {
      this.classList.remove('is-instant');
    }, 1000);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:changed', this.onVariantChanged);
    document.removeEventListener('shopify:section:load', this.onSectionLoad);
    this.mobileQuery.removeEventListener('change', this.onBreakpointChange); // NEW
    this.mainQuantityInput?.removeEventListener('change', this.onMainQuantityChange);
    this.mainQuantityInput?.removeEventListener('input', this.onMainQuantityChange);
    this.stickyQuantityInput?.removeEventListener('change', this.onStickyQuantityChange);
    this.stickyQuantityInput?.removeEventListener('input', this.onStickyQuantityChange);
    this.stickyButton?.removeEventListener('click', this.onStickySubmit);
    this.buyButtonsObserver?.disconnect();
    this.footerObserver?.disconnect();
    this.buttonObserver?.disconnect();
  }

  // NEW
  isMobile() {
    return this.mobileQuery.matches;
  }

  // NEW: re-evaluate when crossing the 699px breakpoint (rotate / resize)
  onBreakpointChange() {
    this.updateVisibilityFromLayout();
  }

  onSectionLoad(event) {
    if (!event?.target?.contains(this)) return;

    this.bindMainFormNodes();
    this.syncFromMain();

    this.buyButtonsObserver?.disconnect();
    this.footerObserver?.disconnect();
    this.setupObservers();
    this.updateVisibilityFromLayout();
  }

  bindMainFormNodes() {
    const previousMainQuantityInput = this.mainQuantityInput;

    this.productForm = document.getElementById(this.dataset.productFormId || '');
    this.mainQuantityInput = this.getMainQuantityInput();
    this.mainButton = this.getMainSubmitButton();
    this.buyButtonsBlock = this.sectionRoot.querySelector('[data-buy-buttons]');
    this.footerElement =
      document.querySelector('footer.footer') ||
      document.querySelector('footer') ||
      document.querySelector('[class*="footer-group"]');

    this.buttonObserver?.disconnect();
    if (this.mainButton) {
      this.buttonObserver = new MutationObserver(() => this.syncButton());
      this.buttonObserver.observe(this.mainButton, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['disabled', 'aria-disabled', 'aria-busy'],
      });
    }

    if (previousMainQuantityInput && previousMainQuantityInput !== this.mainQuantityInput) {
      previousMainQuantityInput.removeEventListener('change', this.onMainQuantityChange);
      previousMainQuantityInput.removeEventListener('input', this.onMainQuantityChange);
    }

    if (this.mainQuantityInput && previousMainQuantityInput !== this.mainQuantityInput) {
      this.mainQuantityInput.addEventListener('change', this.onMainQuantityChange);
      this.mainQuantityInput.addEventListener('input', this.onMainQuantityChange);
    }
  }

  getMainQuantityInput() {
    if (!this.productForm) return null;
    return this.productForm.querySelector('input[name="quantity"]');
  }

  getMainSubmitButton() {
    return this.sectionRoot.querySelector('[data-buy-buttons] [data-atc-btn]');
  }

  setupObservers() {
    if (!this.buyButtonsBlock) return;

    this.buyButtonsObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;

      if (entry.isIntersecting) {
        this.hide();
        return;
      }

      const rect = entry.boundingClientRect;
      // CHANGED: on phones, "not intersecting" means below the fold OR scrolled past
      if (this.isMobile() || rect.bottom < 0 || rect.top < 0) {
        if (!this.hiddenByFooter) {
          this.show();
        }
        return;
      }

      this.hide();
    });

    this.buyButtonsObserver.observe(this.buyButtonsBlock);

    if (!this.footerElement) return;

    this.footerObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;

        if (entry.isIntersecting) {
          this.hiddenByFooter = true;
          this.hide();
          return;
        }

        if (!this.hiddenByFooter) return;

        this.hiddenByFooter = false;
        if (this.shouldShowFromLayout()) {
          this.show();
        }
      },
      {
        rootMargin: '0px 0px 160px 0px',
      }
    );

    this.footerObserver.observe(this.footerElement);
  }

  updateVisibilityFromLayout() {
    if (this.hiddenByFooter) {
      this.hide();
      return;
    }

    if (this.shouldShowFromLayout()) {
      this.show();
    } else {
      this.hide();
    }
  }

  // CHANGED
  shouldShowFromLayout() {
    if (!this.buyButtonsBlock) return false;

    const rect = this.buyButtonsBlock.getBoundingClientRect();

    if (this.isMobile()) {
      // Phones: show whenever the main buy buttons are off screen
      // (below the fold on landing, or scrolled past)
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const inView = rect.bottom > 0 && rect.top < vh;
      return !inView;
    }

    // Tablet / desktop: unchanged
    return rect.bottom < 0 || rect.top < 0;
  }

  show() {
    if (this.isVisible) return;
    this.isVisible = true;
    this.classList.add('is-visible');
    this.setAttribute('aria-hidden', 'false');
  }

  hide() {
    if (!this.isVisible) return;
    this.isVisible = false;
    this.classList.remove('is-visible');
    this.setAttribute('aria-hidden', 'true');
  }

  onVariantChanged(event) {
    if (!this.sectionId) return;
    if (String(event?.detail?.sectionId || '') !== String(this.sectionId)) return;

    window.requestAnimationFrame(() => {
      this.syncFromMain(event.detail?.variant || null);
    });
  }

  onMainQuantityChange() {
    if (!this.stickyQuantityInput || !this.mainQuantityInput || this.isSyncingQuantity) return;
    this.stickyQuantityInput.value = this.mainQuantityInput.value || '1';
  }

  onStickyQuantityChange() {
    if (!this.stickyQuantityInput || !this.mainQuantityInput || this.isSyncingQuantity) return;

    this.isSyncingQuantity = true;
    this.mainQuantityInput.value = this.stickyQuantityInput.value || '1';
    this.mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    this.isSyncingQuantity = false;
  }

  onStickySubmit(event) {
    event.preventDefault();

    if (!this.mainButton) {
      this.productForm?.scrollIntoView({
        block: 'center',
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
      return;
    }

    if (this.mainQuantityInput && this.stickyQuantityInput) {
      this.mainQuantityInput.value = this.stickyQuantityInput.value || '1';
      this.mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.mainButton.click();
  }

  syncFromMain(variant = null) {
    this.bindMainFormNodes();
    this.syncQuantity();
    this.syncPrice();
    this.syncButton();
    this.syncImage(variant);
    this.syncVariantTitle(variant);
  }

  syncQuantity() {
    if (!this.mainQuantityInput || !this.stickyQuantityInput) return;
    this.stickyQuantityInput.value = this.mainQuantityInput.value || '1';
  }

  syncPrice() {
    const mainPrice = this.sectionRoot.querySelector('.product-block__price-row [data-price]');
    const mainCompare = this.sectionRoot.querySelector('.product-block__price-row [data-compare-price]');
    const stickyPrice = this.querySelector('.product-sticky-atc__price-row [data-price]');
    const stickyCompare = this.querySelector('.product-sticky-atc__price-row [data-compare-price]');

    if (!stickyPrice) return;

    if (mainPrice) {
      stickyPrice.innerHTML = mainPrice.innerHTML;
    }

    if (!stickyCompare) return;

    if (mainCompare) {
      stickyCompare.innerHTML = mainCompare.innerHTML;
      stickyCompare.style.display = mainCompare.style.display;
    } else if (mainPrice) {
      stickyCompare.innerHTML = '';
      stickyCompare.style.display = 'none';
    }
  }

  syncButton() {
    if (!this.stickyButton) return;

    if (!this.mainButton) {
      this.stickyButton.disabled = true;
      this.stickyButton.setAttribute('aria-disabled', 'true');
      this.stickyButton.removeAttribute('aria-busy');
      return;
    }

    this.stickyButton.disabled = this.mainButton.disabled;
    this.stickyButton.setAttribute(
      'aria-disabled',
      this.mainButton.getAttribute('aria-disabled') || String(this.mainButton.disabled)
    );

    const mainBusy = this.mainButton.getAttribute('aria-busy');
    if (mainBusy === 'true') {
      this.stickyButton.setAttribute('aria-busy', 'true');
    } else {
      this.stickyButton.removeAttribute('aria-busy');
    }

    const mainLabelNode =
      this.mainButton.querySelector('.btn__label-text--main') ||
      this.mainButton.querySelector('.btn__label');
    const mainLabel = mainLabelNode?.textContent?.trim();
    const stickyMainLabel = this.stickyButton.querySelector('.btn__label-text--main');
    const stickyAltLabel = this.stickyButton.querySelector('.btn__label-text--alt');
    const stickyLabel = this.stickyButton.querySelector('.btn__label');

    if (!mainLabel) return;

    if (stickyMainLabel) stickyMainLabel.textContent = mainLabel;
    if (stickyAltLabel) stickyAltLabel.textContent = mainLabel;
    if (!stickyMainLabel && stickyLabel) stickyLabel.textContent = mainLabel;
  }

  syncImage(variant = null) {
    if (!this.stickyImage) return;

    let mainImage = this.findVariantImage(variant);

    if (!(mainImage instanceof HTMLImageElement)) {
      mainImage = this.sectionRoot.querySelector(
        '.product-gallery__slide.swiper-slide-active img, .product-gallery__grid-item img, .product-gallery__stack-item img'
      );
    }

    if (!(mainImage instanceof HTMLImageElement)) return;

    this.stickyImage.src = mainImage.currentSrc || mainImage.src;
    this.stickyImage.srcset = mainImage.srcset || '';
    this.stickyImage.alt = mainImage.alt || this.stickyImage.alt || '';
  }

  findVariantImage(variant) {
    const mediaId = variant?.featured_media?.id;
    if (!mediaId) return null;

    const escapedId =
      typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
        ? CSS.escape(String(mediaId))
        : String(mediaId).replace(/"/g, '\\"');

    return this.sectionRoot.querySelector(
      `.product-gallery__slide[data-media-id="${escapedId}"] img, .product-gallery__grid-item[data-media-id="${escapedId}"] img, .product-gallery__stack-item[data-media-id="${escapedId}"] img`
    );
  }

  syncVariantTitle(variant = null) {
    if (!this.stickyVariant) return;
    if (variant == null) return;

    const nextTitle = String(variant?.title || '').trim();
    if (!nextTitle || nextTitle === 'Default Title') {
      this.stickyVariant.hidden = true;
      return;
    }

    this.stickyVariant.hidden = false;
    this.stickyVariant.textContent = nextTitle;
  }
}

if (!customElements.get('product-sticky-atc')) {
  customElements.define('product-sticky-atc', ProductStickyAtc);
}